module.exports = __webpack_public_path__ + "img/CD.c6cc7e0f.svg";